import { render, staticRenderFns } from "./new-header-out.vue?vue&type=template&id=9e5f112c&scoped=true"
import script from "./new-header-out.vue?vue&type=script&lang=js"
export * from "./new-header-out.vue?vue&type=script&lang=js"
import style0 from "./new-header-out.vue?vue&type=style&index=0&id=9e5f112c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5f112c",
  null
  
)

export default component.exports